var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFooterDownArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 12,
  viewBox: "0 0 22 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#484848",
  fillRule: "evenodd",
  d: "M19.212.083 21 1.853 11 11.75 1 1.853 2.788.083 11 8.211z"
})));
export default SvgFooterDownArrow;